import { Component } from "@angular/core";
import { GridApi, ColDef, CellValueChangedEvent } from "ag-grid";
import { AgOverlayTemplate } from "../../components/ag-grid/ag-overlay-template";
import { Line, LocationInfo, ScheduleService, Schedules, Country, Port, PortService, OceanLineService, AlertService } from "../../services";
import { AgValueSetter } from "../../components/ag-grid/ag-value-setter";
import { AgAutoCompleteItem, AgAutoCompleteEditor, AgDeleteButtonComponent } from "../../components";
import * as _ from 'lodash';
import { param } from "jquery";

@Component({
  selector: 'schedule-edit',
  templateUrl: 'schedule-edit.html'
})
export class ScheduleEdit {
  gridApi:GridApi;
  selectedocation:LocationInfo = new LocationInfo();

  schedules: Array<Schedules> = [];
  colDefs: ColDef[] = [
    {
      headerName: 'portMapId',
      field: 'portMapId',
      editable: false,
      width: 80
    },
    {
      headerName: '선사', 
      field: 'line',
      valueGetter: params => params.data && params.data.line ? params.data.line.lineCd : params.data.lineCd,
      valueSetter: params => AgValueSetter.valueSetter(params, this.lines, 'lineCd'),
      editable : params => params.data.portMapId ? false : true,
      cellEditor: "lineEditor",
      cellEditorParams: (param) => {return {items: this.lineAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 80
    },
    {
      headerName: '위치',
      field: 'locationId',
      valueGetter: params => params.data.locationId ? params.data.locationId + ', ' + params.data.name : '',
      editable: false,
      width: 200,
      filter: "agTextColumnFilter",
    },
    {
      headerName: '변경할 위치',
      field: 'location',
      valueGetter: params => params.data && params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.ports, 'locationCd'),
      editable: params => params.data.portMapId ? false : true,
      cellEditor: "locationEditor",
      cellEditorParams: (param) => {return {items: this.portAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 200
    },
    {
      headerName: 'portMapCd',
      field: 'portMapCd',
      editable: true,
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: 'portMapCd2',
      field: 'portMapCd2',
      editable: true,
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: 'portMapCd3',
      field: 'portMapCd3',
      editable: true,
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: 'portMapCd4',
      field: 'portMapCd4',
      editable: true,
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: 'portMapCd5',
      field: 'portMapCd5',
      editable: true,
      width: 150,
      filter: "agTextColumnFilter",
    },
    {
      headerName: '삭제',
      field: 'delete',
      editable: false,
      width: 100,
      cellRenderer: 'deleteButton'
    },

  ];

  frameworkComps = {
    locationEditor: AgAutoCompleteEditor,
    lineEditor: AgAutoCompleteEditor,
    deleteButton: AgDeleteButtonComponent
  }    


  overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;

  selectedLine:Line = new Line();

  lines: Line[] = [];
  ports: Port[] = [];
  portAutoCompleteItemList: AgAutoCompleteItem[] = [];
  lineAutoCompleteItemList: AgAutoCompleteItem[] = [];

  context = { componentParent: this };
  
  constructor(private scheduleService: ScheduleService,
    private portService:PortService,
    private oceanLineService:OceanLineService,
    private alertService:AlertService) {

    let ports = this.portService.ports;
    if (!ports || ports.length <= 0) {
        this.portService.portListEe.subscribe(ports => this.initPortAutoCompleteItemList(ports));
    } else this.initPortAutoCompleteItemList(ports);
    
    let lines = this.oceanLineService.lineList;
    if (!lines || lines.length <= 0) {
        this.oceanLineService.lineListEe.subscribe(lines => this.initOceanLineAutoCompleteItemList(lines));
    } else {
      this.initOceanLineAutoCompleteItemList(lines);
    }

  }

  initPortAutoCompleteItemList (portList: Port[]) {
    this.ports = portList;
    this.portAutoCompleteItemList = portList.map((value:Port) => {
      let item = new AgAutoCompleteItem();
      item.value = '[' + value.portCd + '] ' + value.name;
      item.label = value.label;
      item.hiddenLabel = value.label + ' ' + value.labelKr;
      item.code = value.portCd;
      item.data = value;
      return item;
    });    
  }

  initOceanLineAutoCompleteItemList(lines: Line[]) {
    this.lines = lines;
    this.lineAutoCompleteItemList = this.lines.map((line:Line) => {
      if (line.lineCd == 'ZZZ') return;
      
      let item = new AgAutoCompleteItem();
      item.value = '[' + line.lineCd + '] ' + line.lineNm;
      item.label = '[' + line.lineCd + '] ' + line.lineNm;
      item.hiddenLabel = line.lineCd + ' ' + line.lineNm;
      item.code = line.lineCd;
      item.data = line;
      return item;
    });
  }

  
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  portSelected(event) {
    this.selectedocation = event;
  }

  selectLine(event) {
    this.selectedLine = event;
  }

  getSchedules() {
    this.gridApi.showLoadingOverlay();
    if(this.selectedLine && this.selectedLine.lineCd) {
      this.scheduleService.getSchedules(this.selectedLine.lineCd, this.selectedocation.locationId, resp => {
        if(resp) {
          this.schedules = resp;
          this.gridApi.sizeColumnsToFit();
          this.gridApi.hideOverlay();
        }
      });
    } else {
      this.alertService.error('선사 선택은 필수입니다.');
      return;
    }
    
  }
  
  cellValueChanged(event: CellValueChangedEvent) {
    event.data['isUpdate'] = true;
  }

  addNewSchedule() {
    let transIncid: Schedules = new Schedules();
    transIncid.isUpdate = true;
    transIncid.location = new LocationInfo();
    this.schedules.splice(0, 0, transIncid);
    this.gridApi.setRowData(this.schedules);
  }

  saveEditedSchedules() {
    this.gridApi.stopEditing();
    this.gridApi.showLoadingOverlay();
    let saveSchedule = [];
    this.schedules.map(sch => {
      if(sch.isUpdate) {
        let schForPost = {
          lineCd: sch.line && sch.line['lineCd'] ? sch.line.lineCd : sch.lineCd,
          locationId: sch.location && sch.location['locationCd'] ? sch.location.locationId : sch.locationId,
          portMapCd: sch.portMapCd,
          portMapCd2: sch.portMapCd2,
          portMapCd3: sch.portMapCd3,
          portMapCd4: sch.portMapCd4,
          portMapCd5: sch.portMapCd5
        }
        
        if(!this.objectEmptyCheck(schForPost)) saveSchedule.push(schForPost);
      }
    });

    if(!_.isEmpty(saveSchedule)) {
      this.scheduleService.postSchedules(saveSchedule, resp => {
        this.scheduleService.getSchedules(this.selectedLine.lineCd, this.selectedocation ? this.selectedocation.locationId : '', resp => {
          this.schedules = resp;
          this.gridApi.hideOverlay();
        })
      });
    } else {
      this.alertService.error('변경된 사항이 없습니다.');
      this.gridApi.hideOverlay();
      return;
    }
  }

  objectEmptyCheck(obj) {
    for (var key in obj) {
        if (obj[key] !== null && obj[key] != "" && key != 'isUpdate' && obj[key] != undefined)
            return false;
    }
    return true;
  }

  deleteFromParent(params) {
    let delRowData = params.data;
    console.log(delRowData);
    let portMapId = delRowData.portMapId;
    if(!portMapId) {
      let indexFind = params.node.rowIndex;
      this.schedules.splice(indexFind, 1);
      this.gridApi.setRowData(this.schedules);
      return;
    }
    
    this.scheduleService.deleteSchedule(delRowData.lineCd, delRowData.locationId, resp => {
      let indexFind = _.findIndex(this.schedules, {portMapId: portMapId});
      this.schedules.splice(indexFind, 1);
      this.gridApi.setRowData(this.schedules);
    })
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/schedule/schedule-edit.ts